import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FiSearch } from 'react-icons/fi';
import PersonSelectionModal from './PersonSelectionModal';

const BPLCertificate = () => {
  const location = useLocation();
  const navigate = useNavigate();
  // eslint-disable-next-line no-unused-vars
  const { grampanchayatName, arthikVarshLabel } = location.state || {}; 

  const [view, setView] = useState('list'); // 'list' or 'form'
  const [searchTerm, setSearchTerm] = useState('');
  const [showPersonModal, setShowPersonModal] = useState(false);
  
  const [formData, setFormData] = useState({
    certificateNo: '',
    personName: '',
    dueDate: new Date().toISOString().split('T')[0],
    certListNo: '',
    registrationYear: ''
  });

  // Mock data
  const [certificates, setCertificates] = useState([
     // Example data
  ]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handlePersonSelect = (person) => {
    setFormData(prev => ({
      ...prev,
      personName: person.fullName
    }));
  };

  const handleSave = () => {
    console.log("Saving Certificate:", formData);
    // Add validation logic here
    setCertificates(prev => [...prev, { ...formData, id: Date.now() }]);
    resetForm();
    setView('list');
  };

  const handleCancel = () => {
    setView('list');
    resetForm();
  };

  const resetForm = () => {
    setFormData({
        certificateNo: '',
        personName: '',
        dueDate: new Date().toISOString().split('T')[0],
        certListNo: '',
        registrationYear: ''
    });
  };

  return (
    <div className="min-h-screen bg-gray-50 p-4 md:p-8 font-poppins">
      
      {/* Header */}
      <div className="max-w-7xl mx-auto mb-6">
        <div className="bg-[#267c77] rounded-lg shadow-sm p-4 flex justify-between items-center text-white">
            <div>
                 <h1 className="text-xl font-bold">
                    दारिद्र्य रेषेखालील दाखला यादी
                 </h1>
            </div>
            <div className="flex gap-2">
                 <button 
                   onClick={() => navigate('/asthapan/certificates', { state: location.state })}
                   className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600 transition"
                 >
                   मागे जा
                 </button>
                 {view === 'list' && (
                   <button 
                     onClick={() => setView('form')}
                     className="px-4 py-2 bg-[#267c77] text-white rounded hover:bg-[#1e6b66] transition"
                   >
                     नविन
                   </button>
                 )}
            </div>
        </div>
      </div>

      {view === 'list' ? (
        /* LIST VIEW */
        <div className="max-w-7xl mx-auto bg-white rounded-lg shadow-md overflow-hidden">
          
          {/* Search Bar */}
          <div className="p-4 border-b border-gray-200 flex gap-4">
             <div className="relative flex-1">
                <input 
                  type="text" 
                  placeholder="व्यक्तीचे नाव" 
                  className="w-full px-4 py-2 border border-[#267c77]/30 rounded focus:outline-none focus:ring-2 focus:ring-[#267c77]"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
             </div>
             <button className="px-6 py-2 bg-[#267c77] text-white rounded hover:bg-[#1e6b66] transition">
                शोधणे
             </button>
          </div>

          {/* Table */}
          <div className="overflow-x-auto">
            <table className="w-full text-left border-collapse">
              <thead>
                <tr className="bg-[#267c77] text-white">
                  <th className="p-3 border-r border-white/30 font-medium text-center">दाखला क्र.</th>
                  <th className="p-3 border-r border-white/30 font-medium">व्यक्तीचे नाव</th>
                  <th className="p-3 border-r border-white/30 font-medium text-center">देय दिनांक</th>
                  <th className="p-3 font-medium text-center">पर्याय</th>
                </tr>
              </thead>
              <tbody>
                {certificates.length === 0 ? (
                    <tr>
                        <td colSpan="4" className="p-4 text-center text-gray-500">
                            No records found
                        </td>
                    </tr>
                ) : (
                    certificates.map((cert, idx) => (
                        <tr key={idx} className="hover:bg-gray-50 border-b">
                            <td className="p-3 border-r text-center">{cert.certificateNo}</td>
                            <td className="p-3 border-r">{cert.personName}</td>
                            <td className="p-3 border-r text-center">{cert.dueDate}</td>
                            <td className="p-3 text-center flex justify-center gap-2">
                                {/* Options */}
                            </td>
                        </tr>
                    ))
                )}
              </tbody>
            </table>
          </div>

           {/* Pagination */}
           <div className="p-2 border-t bg-[#267c77] text-white flex justify-center items-center gap-2">
                <button className="px-2 py-1 bg-white/20 rounded hover:bg-white/30 text-sm">|&lt;</button>
                <button className="px-2 py-1 bg-white/20 rounded hover:bg-white/30 text-sm">&lt;&lt;</button>
                <span className="px-3 py-1 bg-white/20 rounded text-sm bg-[#1e6b66]">1</span>
                <button className="px-2 py-1 bg-white/20 rounded hover:bg-white/30 text-sm">&gt;&gt;</button>
                <button className="px-2 py-1 bg-white/20 rounded hover:bg-white/30 text-sm">&gt;|</button>
                <select className="ml-2 bg-white text-black text-sm p-1 rounded">
                    <option>5</option>
                    <option>10</option>
                    <option>20</option>
                </select>
           </div>
        </div>
      ) : (
        /* FORM VIEW */
        <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-md p-6 border-t-4 border-[#267c77]">
             <div className="mb-6 border-b pb-2">
                 <h2 className="text-xl font-medium text-white bg-[#267c77] inline-block px-4 py-1 rounded-t-lg w-full">दारिद्र्य रेषेखालील दाखला</h2>
             </div>
            <div className="space-y-6">
                
                {/* Certificate No */}
                <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
                    <label className="text-gray-700 font-medium md:col-span-1">दाखला क्र. :</label>
                    <div className="md:col-span-3">
                         <input 
                            type="text" 
                            name="certificateNo"
                            value={formData.certificateNo}
                            onChange={handleInputChange}
                            placeholder="दाखला क्र."
                            className="w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-[#267c77] py-1.5 bg-gray-100"
                         />
                    </div>
                </div>

                 {/* Person Name */}
                 <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
                    <label className="text-gray-700 font-medium md:col-span-1">व्यक्तीचे नाव :</label>
                    <div className="md:col-span-3 flex gap-0">
                         <input 
                            type="text"
                            name="personName"
                            value={formData.personName}
                            onChange={handleInputChange} 
                            placeholder="व्यक्तीचे नाव"
                            className="flex-1 p-2 border border-[#267c77]/30 rounded-l focus:ring-2 focus:ring-[#267c77] py-1.5 bg-gray-100"
                         />
                         <button 
                            onClick={() => setShowPersonModal(true)}
                            className="px-4 bg-[#267c77] text-white rounded-r hover:bg-[#1e6b66]"
                        >
                            ...
                         </button>
                    </div>
                </div>

                {/* Due Date (Deo Dinank) */}
                <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
                    <label className="text-gray-700 font-medium md:col-span-1">देय दिनांक :</label>
                    <div className="md:col-span-3 relative">
                         <input 
                            type="date"
                            name="dueDate"
                            value={formData.dueDate}
                            onChange={handleInputChange} 
                            className="w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-[#267c77] py-1.5"
                         />
                    </div>
                </div>

                 {/* Certificate List No (Dakhla No) */}
                 <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
                    <label className="text-gray-700 font-medium md:col-span-1">दाखला नं. :</label>
                    <div className="md:col-span-3">
                         <input 
                            type="text" 
                            name="certListNo"
                            value={formData.certListNo}
                            onChange={handleInputChange}
                            placeholder="दाखला नं. भरा"
                            className="w-full p-2 border border-[#267c77]/30 rounded focus:ring-2 focus:ring-[#267c77] py-1.5"
                         />
                    </div>
                </div>

                {/* Registration Year (Nondani Varsha) */}
                <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
                    <label className="text-gray-700 font-medium md:col-span-1">नोंदणी वर्ष :</label>
                    <div className="md:col-span-3 relative">
                         <input 
                            type="text"
                            name="registrationYear"
                            value={formData.registrationYear}
                            onChange={handleInputChange} 
                            placeholder="नोंदणी वर्ष भरा"
                            className="w-full p-2 border border-[#267c77]/30 rounded focus:ring-2 focus:ring-[#267c77] py-1.5"
                         />
                    </div>
                </div>

            </div>

             {/* Footer Buttons */}
             <div className="mt-8 flex justify-center gap-4 py-4 bg-[#267c77] rounded-b-lg -mx-6 -mb-6">
                <button 
                  onClick={handleSave}
                  className="px-6 py-2 bg-[#267c77] text-white rounded hover:bg-[#1e6b66] transition font-medium"
                >
                    साठविणे
                </button>
                <button 
                  onClick={handleCancel}
                  className="px-6 py-2 bg-red-500 text-white rounded hover:bg-red-600 transition font-medium"
                >
                    रद्द करणे
                </button>
             </div>
        </div>
      )}

      {/* Person Selection Modal */}
      <PersonSelectionModal 
        isOpen={showPersonModal}
        onClose={() => setShowPersonModal(false)}
        onSelect={handlePersonSelect}
      />
    </div>
  );
};

export default BPLCertificate;
